import { Query, SmartViewDataView } from '@varo/graphql-schema-types';
import SmartViews from 'services/graphql/queries/SmartView';
import { CombinedError, useQuery } from 'urql';

interface smartViewDataResult {
  smartViewData: SmartViewDataView | null;
  error?: CombinedError;
  isLoading: boolean;
  refresh: () => void;
}

const useSmartViews = (
  accountId: string,
  categoryId: string,
  skip?: boolean,
): smartViewDataResult => {
  const [{ data, error, fetching }, refresh] = useQuery<Query>({
    query: SmartViews,
    variables: {
      input: {
        accountId: accountId,
        categoryId: categoryId,
      },
    },
    requestPolicy: 'cache-first',
    pause: skip,
  });

  return {
    smartViewData: error ? null : (data?.smartView as SmartViewDataView),
    error,
    isLoading: fetching,
    refresh: refresh,
  };
};

export default useSmartViews;
